/**
 * Formats a field name by converting camelCase/PascalCase to human-readable format.
 * Handles special cases and acronyms appropriately.
 *
 * @param fieldName - The field name to format
 * @returns The formatted field name with proper spacing
 *
 * @example
 * formatFieldName('AllowSpecialInstructions') // 'Allow Special Instructions'
 * formatFieldName('ThirdPartyImage') // 'Third Party Image'
 * formatFieldName('itemName') // 'item Name'
 * formatFieldName('XMLParser') // 'XML Parser'
 */
export function formatFieldName(fieldName: string): string {
    if (!fieldName) {
        return fieldName;
    }

    // Handle special cases first
    const specialCases: { [key: string]: string } = {
        AllowSpecialInstructions: 'Allow Special Instructions',
        ThirdPartyImage: 'Third Party Image',
        ThirdPartyDescription: 'Third Party Description'
    };

    if (specialCases[fieldName]) {
        return specialCases[fieldName];
    }

    // General camelCase/PascalCase parsing
    // Insert space before uppercase letters that follow lowercase letters or numbers
    // or before uppercase letters followed by lowercase letters (for acronyms)
    return fieldName
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')  // camelCase boundaries
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2'); // Acronym boundaries (e.g., "XMLParser" -> "XML Parser")
}
